import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";

type ProviderUrl = {
    id: string;
    prefix: string;
    provider?: string;
};

const requests = {
    destroy: (config: AxiosRequestConfig, url: ProviderUrl) =>
        api.delete(`${url.prefix}/${url.id}`, config),
    fetch: (config: AxiosRequestConfig, url: ProviderUrl) =>
        api.get(`${url.prefix}`, config),
    fetchDefault: (config: AxiosRequestConfig, url: ProviderUrl) =>
        api.get(`${url.prefix}/defaults`, config),
    fetchAll: (config: AxiosRequestConfig, url: ProviderUrl) =>
        api.get(`${url.prefix}/all`, config),
    get: (config: AxiosRequestConfig, url: ProviderUrl) =>
        api.get(`${url.prefix}/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig, url: ProviderUrl) =>
        api.post(`${url.prefix}/${url.id}`, data, config),
    storeGenerateKey: (
        data: object,
        config: AxiosRequestConfig,
        url: ProviderUrl
    ) => api.post(`${url.prefix}/${url.id}/generate-key`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: ProviderUrl) =>
        api.put(`${url.prefix}/${url.provider}/${url.id}`, data, config),
    updateGenerateKey: (
        data: object,
        config: AxiosRequestConfig,
        url: ProviderUrl
    ) =>
        api.put(
            `${url.prefix}/${url.provider}/${url.id}/generate-key`,
            data,
            config
        ),
};

export default requests;
